<!-- 
  注文履歴のデザイン詳細
-->
<template>
  <div class="modal" @click="closeAction">
    <div class="content" @click.stop="noAction">
      <div class="container overflow-auto" style="height: 90%">
        <div
          class="row align-items-center my-3 pb-3"
          v-for="data in this.listData"
          :key="data.hisotryId"
          style="height: 200px"
        >
          <div class="col-4" style="height: 85%">
            <img class="h-100 bg-light" v-bind:src="returnFrontPath(data)" />
          </div>
          <div class="col-4" style="height: 85%">
            <img class="h-100 bg-light" v-bind:src="returnBackPath(data)" />
          </div>
          <div class="col-2 m-0 p-0 text-center" style="position: relative">
            <img
              style="
                height: 125px;
                width: 100px;
                object-fit: cover;
                object-position: 50% 0;
              "
              v-bind:src="returnTagPath(data)"
            />
            <img
              class=""
              src="@/assets/tagmask.png"
              style="
                position: absolute;
                top: 0px;
                left: 0px;
                right: 0px;
                margin: auto;
                width: 100px;
                height: 125px;
                z-index: 100;
              "
            />
          </div>
          <div class="col-2 m-0 p-0 text-center" style="position: relative">
            <img
              style="
                height: 125px;
                width: 100px;
                object-fit: cover;
                object-position: 0 100%;
              "
              :class="{ rotate: check(returnTagPath(data)) }"
              v-bind:src="returnTagPath(data)"
            />
            <img
              class=""
              src="@/assets/tagmask.png"
              style="
                position: absolute;
                top: 0px;
                left: 0px;
                right: 0px;
                margin: auto;
                width: 100px;
                height: 125px;
                z-index: 100;
              "
            />
          </div>
          <div class="col-12">
            <button
              @click="addCartAction(data)"
              class="btn btn-sm text-light border dark mt-2 mb-2 mr-2 ml-2 px-3"
            >
              カートに追加
            </button>
          </div>
        </div>
      </div>
      <div class="container" @click.stop="noAction">
        <div class="row">
          <div class="col justify-content-center pt-2">
            <button class="btn btn-dark" @click="closeAction">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";
import Vue from "vue";
import { FirebaseCommon } from "@/js/FirebaseCommon.js";
import { ProductData } from "@/js/ProductData.js";
import JSZip from "jszip";
import { RealtimeDatabaseTableName } from "@/js/Const.js";

export default {
  name: "OrderHistoryDesignDetail",
  props: {},

  data: function () {
    return {
      wkData: [],
      listData: [],
      pathDic: {},
    };
  },
  async created() {
    this.wkData = await this.getData();
        console.log(this.wkData);

    this.getPathData();
    this.listData = this.wkData;
  },

  methods: {
    check(data) {
      return data.indexOf("tagsample") == -1;
    },

    getData() {
      return new Promise((resolve) => {
        if (this.$store.state.designListData) {
          let orderId = this.$store.state.designListData.order_id;
          // 注文に紐づくデータの取得
          var commentsRef = firebase
            .database()
            .ref(RealtimeDatabaseTableName.HistoryData + "/" + firebase.auth().currentUser.uid);
          commentsRef.once("value", (snapshot) => {
            let listData = snapshot.val() ? snapshot.val() : [];
            let returnData = [];

            listData.forEach((d) => {
              if (d.orderId == orderId) {
                returnData.push(d);
              }
            });
            resolve(returnData);
          });
        }
      });
    },
    async addCartAction(data) {
      this.$store.commit("showLoading");

      // zipをダウンロードしてjsonを解析
      let info = await this.downloadZip(data);
      await this.$store.state.saleProductManager.update().catch((e) => {
        this.$common.log(e);
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", "エラーが発生しました");
      });
      let saleProduct = this.$store.state.saleProductManager.getProduct(data.productId);

      let p = new ProductData(
        saleProduct,
        saleProduct.productData["product_class_list2"].filter(
          (d) =>
            d["classcategory_id1"] == data.classcategory_id1 &&
            d["classcategory_id2"] == data.classcategory_id2
        )[0]
      );
      p.quantity = info.productJson.quantity;
      p.tagInfo = info.productJson.tagInfo;
      p.setPrintInfo(info.productJson.printInfo);
      p.tagTemplateName = info.productJson.tagTemplateName;
      p.whiteCount = info.productJson.whiteCount;
      //await p.updateCanvas(info, data.historyId);

      if (p.tagInfo == "noTag") {
        this.$store.commit("addProduct", p);
        this.$store.commit("hideModal");
        this.$store.commit("selectCanvasData", p.canvasDatas[0]);
      } else {
        for (let key in this.$store.state.userTagList) {
          let userData = this.$store.state.userTagList[key];

          let material = this.$common.getMaterialFromCategoryId(
            data.productId,
            p.categoryData["classcategory_id1"]
          );

          if (
            userData["material"] == material &&
            userData["size"] == p.categoryData["classcategory_id2"] &&
            userData["templateName"] == info.productJson.tagTemplateName &&
            userData["productId"] == data.productId
          ) {
            let urls = await this.$common.getTagPath(userData);
            p.frontTagPath = urls[0];
            p.backTagPath = urls[1];
            this.$store.commit("addProduct", p);
            this.$store.commit("hideModal");
            this.$store.commit("selectCanvasData", p.canvasDatas[0]);
            break;
          }
        }
      }
      this.$store.commit("hideLoading");
      this.$store.commit("showMessage", "カートに追加しました");
    },
    downloadZip(data) {
      return new Promise((resolve) => {
        firebase
          .storage()
          .ref()
          .child(FirebaseCommon.getBaseFilePath() + FirebaseCommon.getZipFileName(data.historyId))
          .getDownloadURL()
          .then((url) => {
            this.$blankAxios
              .get(url, {
                responseType: "blob",
                headers: { Accept: "application/zip" },
              })
              .then((response) => {
                const blob = new Blob([response.data], { type: "application/zip" });
                const file = new File([blob], "", {});
                JSZip.loadAsync(file).then((res) => {
                  // resがZip
                  let jsonFile = res.file(data.historyId + "/product.json");
                  jsonFile.async("string").then((fdata) => {
                    let jsonobj = JSON.parse(fdata);
                    resolve({
                      zipData: res,
                      productJson: jsonobj,
                    });
                  });
                });
              })
              .catch((error) => {
                this.$common.log(error);
              });
          })
          .catch((error) => {
            this.$common.log(error);
          });
      });
    },
    getPathData() {
      for (let d of this.wkData) {
        this.getFrontPath(d).then((path)=>{
          Vue.set(this.pathDic, d.historyId + "front", path);
        })
        this.getBackPath(d).then((path)=>{
          Vue.set(this.pathDic, d.historyId + "back", path );
        })
        this.getTagPath(d).then((path)=>{
          Vue.set(this.pathDic, d.historyId + "tag", path);
        })
      }
    },

    noAction() {},
    closeAction: function () {
      this.$store.commit("hideDesign");
    },
    async getFrontPath(data) {
      try {
        let path = await FirebaseCommon.getImageUrl(
          FirebaseCommon.getHistoryFrontFileName(data.historyId)
        );

        if (!path) {
          return `https://ship-resource.s3-ap-northeast-1.amazonaws.com/resource/${data.productId}_${data.classcategory_id1}_${data.classcategory_id2}_front.png`;
          // return require(`@/assets/${data.productId}_${data.classcategory_id1}_${data.classcategory_id2}_front.png`);
        }
        return path;
      } catch {
        return require(`@/assets/${data.productId}_${data.classcategory_id2}_front.png`);
      }
    },
    async getBackPath(data) {
      try {
        let path = await FirebaseCommon.getImageUrl(
          "history_back_" + data.historyId + ".png"
        );
        if (!path) {
          return `https://ship-resource.s3-ap-northeast-1.amazonaws.com/resource/${data.productId}_${data.classcategory_id1}_${data.classcategory_id2}_back.png`;
        }
        return path;
      } catch {
        return require(`@/assets/${data.productId}_${data.classcategory_id2}_back.png`);
      }
    },
    async getTagPath(data) {
      if (data.tagInfo == "withTag" && data.tagtemplate) {
        let path = await this.$common.getTagPathFromTemplateName(
          this.$store.state.userTagList,
          data.productId,
          data.tagtemplate,
          this.$common.getMaterialFromCategoryId(data.productId, data.classcategory_id1),
          data.classcategory_id2
        );
        return path;
      } else {
        return require("@/assets/tagsample.png");
      }
    },
    returnFrontPath(d) {
      if (!d) {
        return "";
      }
      return this.pathDic[d.historyId + "front"];
    },
    returnBackPath(d) {
      if (!d) {
        return "";
      }
      return this.pathDic[d.historyId + "back"];
    },
    returnTagPath(d) {
      if (!d) {
        return "";
      }
      let path = this.pathDic[d.historyId + "tag"];
      return path;
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal {
  z-index: 120;

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  display: flex;
  align-items: center;
  justify-content: center;
}
.content {
  z-index: 121;
  width: 700px;
  min-width: 700px;
  max-width: 700px;
  height: 700px;
  max-height: 700px;
  min-height: 700px;
  padding: 1em;
  overflow-y: scroll;
  background-color: rgb(85, 82, 82);
  border: 3px solid rgb(215, 215, 215);
}
.rotate {
  transform: rotate(180deg);
}
</style>
